import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

const ContactUs = () => {
  const [search, setSearch] = useState("");

  const partners = [
    {
      name: "Dzyris Vasai",
      city: "Mumbai / Vasai",
      state: "Maharashtra",
      code: "DV",
      phone: "+91 9860405100",
      desc: "Local retail & distribution",
    },
    {
      name: "Al Barkat",
      city: "Surat",
      state: "Gujarat",
      code: "AB",
      phone: "+91 9537678234",
      desc: "Wholesale & retail",
    },
    {
      name: "MS Frozen",
      city: "Ahmedabad",
      state: "Gujarat",
      code: "MS",
      phone: "+91 8141687555",
      desc: "Wholesale & retail",
    },
    {
      name: "DS Trading",
      city: "Bhuj",
      state: "Gujarat",
      code: "DS",
      phone: "+91 9924744197",
      desc: "Wholesale & retail",
    },
    {
      name: "Sea King Fresh & Frozen Foods",
      city: "Hyderabad",
      state: "Telangana",
      code: "SK",
      phone: "+91 8008309157",
      desc: "Wholesale & retail",
    },
    {
      name: "AL-Heaven Frozen Foods Hub",
      city: "Anand",
      state: "Gujarat",
      code: "AH",
      phone: "+91 9909801063",
      desc: "Wholesale & retail",
    },
        {
      name: "Mak Frozen Hub",
      city: "Ankleshwar",
      state: "Gujarat",
      code: "Ak",
      phone: "+91 7383436436",
      desc: "Wholesale & retail",
    },
  ];

  // FILTER
  const filteredPartners = partners.filter((p) => {
    const value = search.toLowerCase();
    return (
      p.name.toLowerCase().includes(value) ||
      p.city.toLowerCase().includes(value) ||
      p.state.toLowerCase().includes(value)
    );
  });

  // GROUP BY STATE
  const groupedPartners = filteredPartners.reduce((acc, partner) => {
    if (!acc[partner.state]) {
      acc[partner.state] = [];
    }
    acc[partner.state].push(partner);
    return acc;
  }, {});

  // Hover Effects
  const handleEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-8px)";
    e.currentTarget.style.boxShadow = "0 15px 35px rgba(239,68,68,0.25)";
  };

  const handleLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.08)";
  };

  return (
    <div>
      <Header />

      <div style={styles.container}>
        {/* HEAD OFFICE */}
        <div style={styles.headCard}>
          <div style={styles.logoBox}>DFF</div>

          <div>
            <span style={styles.badge}>Headquarters & Manufacturing</span>
            <h2 style={styles.company}>Dzyris Frozen Foods Private Limited</h2>
            <p style={styles.address}>
              Kaman Road, Vasai (East), Palghar — Maharashtra 401209
            </p>
            <p style={styles.contact}>
              +91 8956622450 • dzyrisfrozenfoods@gmail.com
            </p>
          </div>
        </div>

        {/* TITLE */ } 
        <h3 style={styles.sectionTitle}>OUR DISTRIBUTION PARTNERS</h3>

        {/* SEARCH */}
        <div style={styles.searchBox}>
          <input
            type="text"
            placeholder="Search by city, state, or distributor name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.searchInput}
          />
        </div>

        {/* NO RESULT */}
        {Object.keys(groupedPartners).length === 0 && (
          <p style={{ textAlign: "center", color: "#991b1b" }}>
            No distributors found
          </p>
        )}

        {/* STATE-WISE SECTIONS */}
        {Object.keys(groupedPartners).map((state, index) => (
          <div key={index} style={styles.stateSection}>
            <h2 style={styles.stateTitle}>
              <span style={styles.stateDot}></span>
              {state}
            </h2>

            <div style={styles.grid}>
              {groupedPartners[state].map((p, i) => (
                <div
                  key={i}
                  style={styles.card}
                  onMouseEnter={handleEnter}
                  onMouseLeave={handleLeave}
                >
                  <div style={styles.cardTop}>
                    <div style={styles.avatar}>{p.code}</div>

                    <div>
                      <span style={styles.state}>{p.state}</span>
                      <h4 style={styles.name}>{p.name}</h4>
                      <p style={styles.city}>● {p.city}</p>
                    </div>
                  </div>

                  <hr style={styles.divider} />
                  <p style={styles.desc}>{p.desc}</p>

                  <a href={`tel:${p.phone}`} style={styles.phone}>
                    {p.phone}
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* ADD PARTNER */}
        <div style={styles.addCard}>
          <div style={styles.plus}>+</div>
          <p>Become a partner in your city</p>

          <button
            style={styles.enquireBtn}
            onClick={() =>
              window.open(
                `https://wa.me/919022707285?text=Hi%20I%20want%20to%20become%20a%20distribution%20partner`,
                "_blank"
              )
            }
          >
            Enquire →
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;

/* ================= STYLES ================= */

const styles = {
  container: {
    padding: "40px 20px",
    background: "linear-gradient(135deg, #fff1f2, #ffe4e6)",
    minHeight: "100vh",
    fontFamily: "'Poppins', sans-serif",
  },

  headCard: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    background: "linear-gradient(135deg, #ffffff, #fff5f5)",
    padding: "25px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(239,68,68,0.15)",
    marginBottom: "40px",
    border: "1px solid #fee2e2",
  },

  logoBox: {
    width: "65px",
    height: "65px",
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    color: "white",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: "18px",
  },

  badge: {
    background: "#fee2e2",
    padding: "5px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    color: "#b91c1c",
  },

  company: {
    margin: "6px 0",
    color: "#111",
    fontWeight: "600",
  },

  address: {
    color: "#555",
    fontSize: "14px",
  },

  contact: {
    color: "#ef4444",
    fontSize: "14px",
    fontWeight: "500",
  },

  sectionTitle: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "13px",
    letterSpacing: "2px",
    color: "#991b1b",
    fontWeight: "600",
  },

  searchBox: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "30px",
  },

  searchInput: {
    width: "100%",
    maxWidth: "400px",
    padding: "12px 18px",
    borderRadius: "25px",
    border: "1px solid #fecaca",
    outline: "none",
    fontSize: "14px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },

  stateSection: {
    background: "rgba(255,255,255,0.75)",
    backdropFilter: "blur(10px)",
    borderRadius: "18px",
    padding: "20px",
    marginBottom: "35px",
    border: "1px solid #fee2e2",
    boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
  },

  stateTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#7f1d1d",
    marginBottom: "18px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  stateDot: {
    width: "10px",
    height: "10px",
    background: "#ef4444",
    borderRadius: "50%",
    boxShadow: "0 0 8px rgba(239,68,68,0.6)",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 260px))",
    gap: "20px",
    justifyContent: "center",
  },

  card: {
    background: "linear-gradient(135deg, #ffffff, #fff7f7)",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    transition: "all 0.3s ease",
    border: "1px solid #fee2e2",
    cursor: "pointer",
  },

  cardTop: {
    display: "flex",
    gap: "12px",
  },

  avatar: {
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #ef4444, #f87171)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
  },

  state: {
    fontSize: "11px",
    background: "#fee2e2",
    padding: "3px 10px",
    borderRadius: "12px",
    color: "#b91c1c",
  },

  name: {
    margin: "5px 0",
    fontSize: "16px",
    fontWeight: "600",
  },

  city: {
    fontSize: "13px",
    color: "#666",
  },

  divider: {
    margin: "12px 0",
    borderColor: "#fee2e2",
  },

  desc: {
    fontSize: "13px",
    color: "#555",
  },

  phone: {
    color: "#ef4444",
    fontSize: "13px",
    textDecoration: "none",
    fontWeight: "500",
  },

  addCard: {
    border: "2px dashed #ef4444",
    borderRadius: "16px",
    padding: "25px",
    textAlign: "center",
    color: "#b91c1c",
    background: "rgba(239,68,68,0.05)",
    marginTop: "30px",
  },

  plus: {
    fontSize: "26px",
    marginBottom: "10px",
    fontWeight: "bold",
  },

  enquireBtn: {
    marginTop: "12px",
    padding: "8px 16px",
    borderRadius: "20px",
    border: "none",
    background: "#ef4444",
    color: "white",
    cursor: "pointer",
    fontSize: "13px",
  },
};